import memoize from '../../../common/utils/memoize';
import * as commentsReducer from '../reducers/comments';

const getComment = (state, id) => state.social.comments.items[id];

export const item = memoize.createItemSelector(
  [getComment],
  (state, comment) => comment && commentsReducer.findById(state, comment.id),
);
